export default __webpack_public_path__ + "static/media/img2.c1704940.JPG";